import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState } from '../../../../../services/interfaces';
import { RoundMode } from '../../../../../services/interfaces';
import { translateEntity } from '../../../../../services/utils';
import { getSeasonLabel, setCssVariant } from '../../helpers';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
};

const MatchInfo = ({ state }: Props) => {
  const size = state.size;
  const cssVariant = setCssVariant(size);

  const match = state.matchData;
  if (!match) return null;

  const roundName = translateEntity(match.round)?.name;
  const groupName = translateEntity(match.group)?.name;
  const leagueName = translateEntity(match.group?.league)?.name;
  const stadiumName = translateEntity(match.stadium)?.name;
  const venueName = translateEntity(match.stadium?.city)?.name;
  const legName = translateEntity(match.leg)?.name;
  const seasonLabel = getSeasonLabel(match);

  const showRound = !state.hideRound;
  const showContext = !state.hideContext;
  const showSeason = state.showSeason;
  const showLocation = state.showLocation;

  return (
    <div class={{ [`pk-match__info`]: true, ...cssVariant }} part="match-info">
      {showLocation && (
        <div class={{ [`pk-match__info--location`]: true, ...cssVariant }} hidden={!stadiumName} part="location">
          {!!stadiumName && (
            <span class="stadium" part="stadium">
              {stadiumName}
            </span>
          )}
          {!!stadiumName && !!venueName && <span class="location-divider"></span>}
          {!!venueName && (
            <span class="venue" part="venue">
              {venueName}
            </span>
          )}
        </div>
      )}
      <div class={{ [`pk-match__info--data`]: true, ...cssVariant }} part="data">
        {showContext && match.round?.mode === RoundMode.GROUP && match.round?.groupCount > 1 && (
          <span class="group-name" part="group-name">
            {!!leagueName && <span class="league-name">{leagueName}</span>}
            {groupName}
          </span>
        )}
        {showRound && ([RoundMode.KNOCK_OUT, RoundMode.FINAL] as RoundMode[]).includes(match.round?.mode) && (
          <span class="round-name" part="round-name">
            {roundName}
            {match.round?.mode === RoundMode.KNOCK_OUT && legName && `, ${legName}`}
          </span>
        )}
        {showSeason && seasonLabel && (
          <span class="season-label" part="season-label">
            {showRound && ', '}
            {seasonLabel}
          </span>
        )}
      </div>
    </div>
  );
};

export { MatchInfo };
